import React from 'react'
import styled from 'styled-components'
import { Modal } from './Modal'
import { Text } from '../Text'
import { LoginForm } from '../Form/LoginForm'
import { FacebookLoginButton } from '../Button/FacebookLoginButton'
import { GoogleLoginButton } from '../Button/GoogleLoginButton'
import { STYLES } from '../../static/style'
import { SocialLoginContainer } from './SocialLoginContainer'
import { ModalSeparator } from './ModalSeparator'

const TitleText = styled(Text)`
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  display: block;
  margin: 2rem 0 1rem;
  text-align: center;
`

interface LoginModalProps {
  title?: string
  isAuthByCognito?: boolean
  isAuthByFacebook?: boolean
  isAuthByGoogle?: boolean
  hasSignUp?: boolean
}

const LoginModal = ({
  title,
  isAuthByCognito,
  isAuthByFacebook,
  isAuthByGoogle,
  hasSignUp,
}: LoginModalProps) => (
  <Modal maxWidth={25} showLogo>
    {title && <TitleText>{title}</TitleText>}
    {isAuthByCognito && (
      <LoginForm
        hasSignUp={hasSignUp}
        isAuthByCognito={isAuthByCognito}
        isAuthByFacebook={isAuthByFacebook}
        isAuthByGoogle={isAuthByGoogle}
      />
    )}
    {isAuthByCognito && (isAuthByGoogle || isAuthByFacebook) && (
      <ModalSeparator />
    )}
    {(isAuthByGoogle || isAuthByFacebook) && (
      <SocialLoginContainer>
        {/*
        {isAuthByFacebook && <FacebookLoginButton />}
*/}
        {isAuthByGoogle && <GoogleLoginButton />}
      </SocialLoginContainer>
    )}
  </Modal>
)

export { LoginModal }
